import React, { useState, useEffect } from 'react';
import { useToast } from '../../../contexts/ToastProvider';
import Toast from '../Toast/Toast';
import styles from './Toaster.module.css';

const Toaster: React.FC = () => {
  const { toasts, removeToast } = useToast();
  const [exitingToasts, setExitingToasts] = useState<Set<string>>(new Set());

  const handleClose = (id: string) => {
    // Mark toast as exiting to trigger exit animation
    setExitingToasts((prev) => new Set(prev).add(id));
    
    // Remove from exiting set and toasts after animation completes
    setTimeout(() => {
      setExitingToasts((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      removeToast(id);
    }, 300); // Match animation duration
  };

  // Clean up exiting toasts when they're removed from toasts array
  useEffect(() => {
    const toastIds = new Set(toasts.map((t) => t.id));
    setExitingToasts((prev) => {
      const next = new Set(prev);
      prev.forEach((id) => {
        if (!toastIds.has(id)) {
          next.delete(id);
        }
      });
      return next;
    });
  }, [toasts]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={styles.toaster} aria-live="polite" aria-label="Notifications">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toastWrapper} ${
            exitingToasts.has(toast.id) ? styles.exiting : ''
          }`}
        >
          <Toast
            id={toast.id}
            message={toast.message}
            variant={toast.variant}
            duration={toast.duration}
            onClose={handleClose}
          />
        </div>
      ))}
    </div>
  );
};

export default Toaster;

